<template>
	<div v-if="device=='pc'">
		<box :customer="true" :autoLoad="true" :ref="boxRef" title="收款账号" :width="1000" :index="0" @hide="hide" @submit="submit"
			moduleName="supplieraccount" :store="store" selectType="radio"
			@boxdataload="boxdataload" />
	
	</div>
	<div v-else>
		<phonebox :customer="true" :autoLoad="true" :ref="boxRef" title="收款账号" :width="1000" :index="0" @hide="hide" @submit="submit"
			moduleName="supplieraccount" :store="store" selectType="radio"
			@boxdataload="boxdataload" />
	</div>
	
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	//https://detail.tmall.com/item.htm?id=706822484836&spm=a21dvs.23580594.0.0.1d293d0d88sla5 
	import box from '@_system/components/formcomponents/common/box/index.vue'
	import phonebox from '@_system/components/formcomponents/phone/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			supplierwlnid:{
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey:null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [{
						type:"radio",
						field: 'rcvAcc',
						title: '收款账号',
						render: '$input',
					},{
						field: 'rcvBankName',
						title: '开户银行',
						render: '',
					},{
						field: 'accountbusiness',
						title: '业务',
						render: '',
						formatter:'accountbusiness'
					}, {
						field: 'rcvName',
						title: '收款人',
						render: '',
					}, {
						field: 'payaccount',
						title: '付款账号(对公专用)',
						render: '',
						formatter:'paymentaccount'
					}, {
						field: 'mark',
						title: '备注',
						render: '$input',
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 100,
						enabled: false,
						pageSizes: [20, 50, 200],
						force:true
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show

		},
		watch: {

		},
		computed: {
			device(){
				return window.systemMethods.device()
			}
		},

		methods: {
			show() {
				if(this.box.getTable()){
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if(!this.box.gridOptions){
					this.box.initBox(this.boxConfig)
				}				
			},
			list(page, form, other) {
				return new Promise((resolve,reject) => {					
					this.$api.supplier.getAccountByWlnid(this.supplierwlnid,{
						mode: 'box',
						index: this.index,
						...page,
						...form,
						...this.foreingKey,
						...other
					}).then((res) => {
						res.list = res
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box,
			phonebox
		}
	}
</script>
